export default __webpack_public_path__ + "static/media/athens.c0982818.png";